// extracted by mini-css-extract-plugin
module.exports = {"langSelect":"langselectmodal_langSelect__Oj_aF","options":"langselectmodal_options__rxva_","offset":"langselectmodal_offset___YA3j","invisible":"langselectmodal_invisible__diTJb"};